import * as React from 'react';
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Chip
} from '@mui/material';

import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';

import { useNavigate } from 'react-router-dom';

export const DashboardComp = (props) => {

    const navigate = useNavigate();

    const dashboardCards = [

        ...(props.mystate.userData.profile === 'Admin' ||
            props.mystate.userData.profile === 'Marketing'
            ? [
                {
                    title: 'Leads Dashboard',
                    description: 'Lead count, sources and conversion overview',
                    icon: <PeopleAltOutlinedIcon />,
                    route: 'dashboard/leads',
                    tag: 'Marketing',
                    iconBg: '#eef4ff',
                    iconColor: '#2563eb'
                },
                {
                    title: 'Date Wise Report',
                    description: 'Track lead activity by selected dates',
                    icon: <CalendarMonthOutlinedIcon />,
                    route: 'dashboard/date-wise',
                    tag: 'Marketing',
                    iconBg: '#fff7ed',
                    iconColor: '#ea580c'
                }
            ]
            : []),

        ...(props.mystate.userData.profile === 'Admin' ||
            props.mystate.userData.profile === 'Marketing' ||
            props.mystate.userData.profile.includes('Sales')
            ? [
                {
                    title: 'Patch Dashboard',
                    description: 'Monitor patch and onboarding progress',
                    icon: <AnalyticsOutlinedIcon />,
                    route: 'dashboard/patch',
                    tag: 'Sales',
                    iconBg: '#ecfdf5',
                    iconColor: '#16a34a'
                },
                {
                    title: 'Call Logs',
                    description: 'Access calls, recordings and durations',
                    icon: <PhoneInTalkOutlinedIcon />,
                    route: 'dashboard/institute-call-logs',
                    tag: 'Sales',
                    iconBg: '#f5f3ff',
                    iconColor: '#7c3aed'
                },
                {
                    title: 'Student Enrolled',
                    description: 'Track enrolled students and admission statistics',
                    icon: <SchoolOutlinedIcon />,
                    route: 'dashboard/student-enrolled',
                    tag: 'Students',
                    iconBg: '#fef3c7',
                    iconColor: '#d97706'
                }
            ]
            : [])
    ];

    return (

        <Box>
            <Box sx={{ mb: 4 }}>

                <Typography
                    sx={{
                        fontSize: { xs: '24px', md: '30px' },
                        fontWeight: 700,
                        color: '#042740',
                        lineHeight: 1.2,
                        letterSpacing: '-0.5px'
                    }}
                >
                    CRM Dashboard
                </Typography>

                <Typography
                    sx={{
                        mt: 0.75,
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: 400
                    }}
                >
                    Monitor leads, institute onboarding, call activities and sales performance.
                </Typography>

            </Box>

            <Grid container spacing={3}>

                {dashboardCards.map((card, index) => (

                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        key={index}
                    >

                        <Card
                            onClick={() =>
                                navigate('/' + card.route)
                            }
                            sx={{
                                cursor: 'pointer',
                                borderRadius: '16px',
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                height: '100%',
                                transition: 'all .25s ease',

                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow:
                                        '0 12px 24px rgba(0,0,0,0.08)'
                                }
                            }}
                        >

                            <CardContent>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mb: 3
                                    }}
                                >

                                    <Box
                                        sx={{
                                            width: 52,
                                            height: 52,
                                            borderRadius: '14px',
                                            bgcolor: card.iconBg,
                                            color: card.iconColor,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        {card.icon}
                                    </Box>

                                    <Chip
                                        label={card.tag}
                                        size="small"
                                        sx={{
                                            height: 24,
                                            fontSize: '11px',
                                            fontWeight: 600
                                        }}
                                    />

                                </Box>

                                <Typography
                                    sx={{
                                        fontSize: '17px',
                                        fontWeight: 700,
                                        color: '#111827',
                                        mb: 1
                                    }}
                                >
                                    {card.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        lineHeight: 1.6,
                                        color: '#6b7280'
                                    }}
                                >
                                    {card.description}
                                </Typography>

                            </CardContent>

                        </Card>

                    </Grid>

                ))}

            </Grid>

        </Box>

    );
};